export default "__VITE_ASSET__DnufIOUg__"